import React, { useEffect, useState } from 'react'
import axios from 'axios'
import {
  Row,
  Input,
  Col,
  message,
  Button,
  Form,
  Select,
  Modal,
  Table,
  DatePicker,
  Popconfirm,
  Layout,
  Result,
  Checkbox,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
// import AddCustomer from './AddCustomer'
import { CloseOutlined, EditOutlined } from '@ant-design/icons'
import queryString from 'query-string'
import moment from 'moment'
import { Spin } from 'antd'
// import WrappedEditPolicyPopUp from './EditPolicyPopUp'
import apiRequest from '../../hooks/ApiRequest'
import { withRouter } from 'react-router-dom'

const { Option } = Select

const { confirm } = Modal
function roundvalue(value) {
  // for round the vlaues john 24 march 2022
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
const productNameInLocalStorage = localStorage.getItem('productName')
const data = JSON.parse(localStorage.getItem('user'))

class EditCrmPolicy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCorprate: false,
      currentSumInsured: 0.00,
      newSumInsured: 0.00,
      renewButton: false,
      showRenewButton: false,
      showSaveButton: false,
      isActive: false,
      loggedInUser: {},
      isTableViible: 'false',
      taxes: [],
      searchBox: null,
      gotData: false,
      visible: false,
      visibleSearch: false,
      monthlyTermPayment: 0,
      isMonthlyDeduction: false,
      clientId: this.props.match.params.policyId,
      api: 'https://localhost:7279/GetClientDetailsbyid/1',
      access: '',
      brokerId: 0,
      editingRecordId: null,
      a: false,
      transactions: [],
      policyDuration: '12',
      riskCover: '',
      riskItem: '',
      coverType: '',
      data: [],
      riskCoverDrop: [],
      riskItemList: [],
      insurerList: [],
      insurerID: 0,
      riskVar: '',
      ratePercentage: 0.0,
      rate: 0.0,
      Minimum_rate: 0.0,
      riskcoverfortable: '',
      riskitemfortable: '',
      newProduct: {},
      annualPremiumTotal: 0.0,
      termPremiumTotal: 0.0,
      minimumPremium: 0,
      // prorataPremiumTotal: 0.0, //johh 30-03-2022
      tempAddress: '',
      // parentpolicyid: parseInt(localStorage.getItem('clientId')),
      isInsurer: data?.role === '308',
      InsurerFirstName: data?.FirstName,
      InsurerLastName: data?.LastName,
      policyStartDate: '',
      policyEndDate: '',
      paymentterm: '', //john 24-03-2022
      policyriskcover: '', //john 24-03-2022
      record: '', //john 24-03-2022
      entitytype: '', //john 04 April 2022
      clientfirstname: '',
      clientsurname: '',
      clientcorporatename: '',
      clientcontactnumber: '',
      clientemailaddress: '',
      clientage: '',
      clientgender: '',
      clientaddress1: '',
      clientaddress2: '',
      nationalid: '',
      suburb: '',
      city: '',
      riskItemStartDate: new Date(),
      currentDate: new Date(),
      stampDuty: '',
      reinsuranceLimit: '',
      loading: false,
      cellphone: false,
      noOfDaysForRenewal: '',
      noOfDaysForRenewalForSubmit: '',
      currency: '',
      policyriskcoverid: 0,
      setOpen: false,
      policyRiskItemId: 0,
      productId: parseInt(localStorage.getItem('productId')),
      specificProductID: 0,
      policyexpirytdate: "",
      totalRefund: 0,
      grandTotals: {},
      columns: [
        {
          key: 'riskitem',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'risk_item',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        // {
        //   key: 'address',
        //   title: 'Address/Details',
        //   dataIndex: 'address',
        // },
        {
          key: 'suminsured',
          title: 'Sum Insured ($)',
          dataIndex: 'suminsured',
        },
        // {
        //   key: 'rate',
        //   title: 'Rate(%)',
        //   dataIndex: 'rate',
        // },
        {
          key: 'annualpremium',
          title: 'Annual Premium',
          dataIndex: 'annualpremium',
        },
        {
          key: 'termpremium',
          title: 'Term Premium',
          dataIndex: 'termpremium',
        },
        // {
        //   key: 'itempstartdate',
        //   title: 'Start Date',
        //   dataIndex: 'itempstartdate',
        //   render: (text) => moment(text).format('DD-MM-YYYY'),
        // },
        // {
        //   key: 'refund',
        //   title: 'Refund',
        //   dataIndex: 'refund',
        // },
        // {
        //   key: 'collectiblepremium',
        //   title: 'Collectible Premium',
        //   dataIndex: 'collectiblepremium',
        // },
        // {
        //   key: 'collectiblestampduty',
        //   title: 'Collectible Stamp Duty',
        //   dataIndex: 'collectiblestampduty',
        // },


        {
          key: 'action',
          title: 'Action',
          render: (_, record, index) => {
            // New record (not yet saved to DB)
            if (!record.policyriskitemid || record.policyriskitemid === 0) {
              return (
                <>
                  <button
                    className="edit_btn"
                    onClick={() => this.handleEdit(index)}
                  >
                    <EditOutlined />
                  </button>
                  <Popconfirm
                    title="Do you want to remove this Item?"
                    onConfirm={() => this.handleDelete(index)}
                  >
                    <button className="delete_btn">
                      <CloseOutlined />
                    </button>
                  </Popconfirm>
                </>
              );
            }

            return (
              <>
                {record.collectiblepremium === null &&
                  record.collectiblestampduty === null &&
                  record.effectivedate === null ? (
                  <button className="edit_btn" onClick={() => this.handleEdit(index)}>
                    <EditOutlined />
                  </button>
                  // Edit button hidden but comment kept
                ) : (
                  <>
                    <Popconfirm
                      title="Are you sure the transaction has been completed ?"
                      onConfirm={() =>
                        this.handleTransactionCompleted(record.policyriskitemid)
                      }
                    >
                      <button className="edit_btn">Transaction Completed</button>
                    </Popconfirm>
                    <Popconfirm
                      title="Are you sure you want to cancel this transaction ?"
                      onConfirm={() =>
                        this.handleCancelTransaction(record.policyriskitemid)
                      }
                    >
                      <button className="edit_btn">Cancel Transaction</button>
                    </Popconfirm>
                  </>
                )}



                {/*Always show delete for DB records too */}
                <Popconfirm
                  title="Do you want to remove this Item?"
                  onConfirm={() => this.handleDelete(index)}
                >
                  <button className="delete_btn">
                    <CloseOutlined />
                  </button>
                </Popconfirm>
              </>
            );
          },
        }

      ],
      columnsForFCP: [
        {
          key: 'relation',
          title: 'Relationship',
          dataIndex: 'relationship',
          width: '10',
        },
        {
          key: 'riskitem',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'risk_item',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        {
          key: 'name',
          title: 'Member Name',
          dataIndex: 'membername',
          width: '10',
        },
        {
          key: 'gender',
          title: 'Gender',
          dataIndex: 'gender',
          width: '10',
        },
        {
          key: 'age',
          title: 'Age',
          dataIndex: 'age',
          width: '10',
        },
        {
          key: 'suminsured',
          title: 'Sum Insured',
          dataIndex: 'suminsured',
          render: (suminsured) => parseFloat(suminsured || 0).toFixed(2),
          width: '10',
        },
        {
          key: 'annualpremium',
          title: 'Annual Premium',
          dataIndex: 'annualpremium',
          width: '10',
        },
        {
          key: 'termpremium',
          title: 'Term Premium',
          dataIndex: 'termpremium',
          width: '10',
        },
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record, index) => (
            <>
              <button className="edit_btn" onClick={() => this.handleEdit(index)}>
                <EditOutlined />
              </button>
              <Popconfirm
                title="Do you want to remove this Item?"
                onConfirm={() => this.handleDelete(index)}
              >
                <button className="delete_btn">
                  <CloseOutlined />
                </button>
              </Popconfirm>
            </>
          ),
        },
      ],

      // Variables for fetching user info
      res: [],
      clientName: '',
      quotationId: '',
      startDateFromApi: '',
      endDateFromApi: '',
      riskCoverFromApi: [],
      riskItemFromApi: '',
      // clientId: parseInt(localStorage.getItem('clientId')),
      termPremiumTotalForEdit: 0,
      annualPremiumTotalForEdit: 0,
      prorataPremiumTotalForEdit: 0,
      grandtotalannualpremium: 0,
      riskitemid: '',
      dateFormat: 'DD-MM-YYYY HH:mm:ss',
      policyStatus: '',
      productName: '',
      monthlyPremiumTotal: 0,
      sumInsuredTotal: 0,
      prorataTotalTermPremium: 0,
      stampdutytermpremium: 0,
    }
    this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.ShowHideCorporateName = this.ShowHideCorporateName.bind(this)
    this.setVisible = this.setVisible.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.riskitem = this.riskitem.bind(this)
    this.covertype = this.covertype.bind(this)
    this.startdateChange = this.startdateChange.bind(this)
    this.enddateChange = this.enddateChange.bind(this)
    // this.handleSubmitWithId = this.handleSubmitWithId(this);
    this.paymenttermChange = this.paymenttermChange.bind(this) //john 24-03-2022
    this.riskcoverChange = this.riskcoverChange.bind(this) //john 24-03-2022
    this.submitpolicy = this.submitpolicy.bind(this)
    this.onInputchange = this.onInputchange.bind(this)
    this.startdateChangeRiskItem = this.startdateChangeRiskItem.bind(this)
    this.DobFcp = this.DobFcp.bind(this)
    this.state.handleSubmit = this.handleSubmit.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.parseCustomDate = this.parseCustomDate.bind(this)
  }
  // delete record from the grid and perform the calculation  john 24-03-2022
  handleDelete = key => {

    this.state.res[0].riskitemdetails.splice(key, 1)
    this.state.data = []
    this.state.data.push(this.state.res[0].riskitemdetails)
    if (this.state.productId !== 3) {
      let annual_premium = 0
      let term_premium = 0
      let pro_rata = 0
      let totalMonthlyPremium = 0
      for (let i = 0; i < this.state.data[0].length; i++) {
        pro_rata = this.state.data[0][i].prorata + pro_rata
        annual_premium = this.state.data[0][i].annualpremium + annual_premium
        term_premium = this.state.data[0][i].termpremium + term_premium
        if (this.state.productId == 4) {
          totalMonthlyPremium =
            this.state.data[0][i].monthlypremium + totalMonthlyPremium
        }
      }
      this.setState({ prorataPremiumTotalForEdit: roundvalue(pro_rata) })
      this.setState({ annualPremiumTotalForEdit: roundvalue(annual_premium) })
      this.setState({ termPremiumTotalForEdit: roundvalue(term_premium) })
      //   debugger
      this.setState({
        monthlyPremiumTotal: totalMonthlyPremium,
        monthlyTotalPayment: totalMonthlyPremium,
      })
    } else {
      let totalSumInsured = 0
      let totalMonthlyPremium = 0
      for (let i = 0; i < this.state.data[0].length; i++) {
        totalSumInsured = this.state.data[0][i].suminsured + totalSumInsured
        totalMonthlyPremium =
          this.state.data[0][i].monthlypremium + totalMonthlyPremium
      }

      this.setState({
        monthlyPremiumTotal: totalMonthlyPremium,
      })
      this.setState({
        sumInsuredTotal: totalSumInsured,
      })
      this.setState({
        prorataPremiumTotalForEdit: totalMonthlyPremium,
      })
    }
  }

  handleEdit = async (index) => {
    const record = this.state.data[index];
    this.setState({ hasEdited: true, editingRecordId: record.policyriskitemid });
    await this.riskcoverChange(record.policy_cover_id);
    await this.riskitem(parseInt(record.riskitemid));

    // Set form fields
    this.props.form.setFieldsValue({
      riskcover: record.policy_cover_id,
      riskItem: record.riskitemid.toString(),
      address: record.address,
      rate: parseFloat(record.rate).toFixed(2),
      sumInsured: record.suminsured,
      itempstartdate: moment(record.itempstartdate, this.state.dateFormat),
      relation: record?.relationship,
      name: record?.membername,
      VehicleRegistration: this.state?.VehicleRegistration,
      Make: this.state?.Make,
      Model: this.state?.Model,
      Year: this.state?.Year,
    });

    // Update component state for UI
    this.setState({
      riskItemValue: record.riskitemid.toString(),
      riskItemName: record.riskitemname,
      policyCoverValue: record.policy_cover_id,
      rate: record.rate,
      sumInsuredValue: record.suminsured,
      DObValue: record?.dateofbirth ? moment(record.dateofbirth) : null,
      relationValue: record?.relationship,
      ageFcp: record?.age,
      genderValue: record?.gender,
    });
  };

  handleTransactionCompleted = key => {
    console.log(key)
    var productid = localStorage.getItem('productId')
    const response = axios.get(
      process.env.REACT_APP_BASE_URL +
      `/Policy/TransactionCompleted/${key},${productid}`,
    )
    message.success('Transaction completed successfully!!')
    window.location.reload()
  }

  handleCancelTransaction = key => {
    console.log(key)
    var productid = localStorage.getItem('productId')
    const response = axios.get(
      process.env.REACT_APP_BASE_URL +
      `/Policy/CancelTransaction/${key},${productid}`,
    )
    message.success('Transaction cancelled successfully!!')
    window.location.reload()
  }

  applyMinimumPremium = (annualPremium, termPremium) => {
    const minPremium = this.state.minimumPremium
    const appliedAnnualPremium = Math.max(roundvalue(annualPremium), minPremium);
    const appliedTermPremium = Math.max(roundvalue(termPremium), minPremium);
    const overrideNote =
      annualPremium < minPremium || termPremium < minPremium
        ? `Applied minimum premium $${minPremium}`
        : '';
    this.setState({ overrideNotes: overrideNote });

    return { appliedAnnualPremium, appliedTermPremium };
  };


  parseCustomDate(dateStr) {
    // Example input: '22-05-2025 00:00:00'
    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-');
    return new Date(`${year}-${month}-${day}T${timePart}`);
  }

  transactionDetails = async value => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Transaction/GetPolicyTransaction/get-policy-transaction/${value}`,
        'GET',
      )
      if (response.success) {
        this.setState({ transactions: response.data })
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Request failed:', error)
    }
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.setState({ loggedInUser: JSON.parse(localStorage.getItem('user')) });
    const parsed = queryString.parse(window.location.search);
    const { clientId, currentDate } = this.state;

    if (clientId !== null) {
      apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicybyid/${clientId}`,
        'GET',
      ).then(policyResponse => {
        if (!policyResponse.success) throw new Error('Policy fetch failed');

        const { policydetail, customerdetail } = policyResponse.data;
        const riskItems = policydetail?.riskitemdetails || [];

        const updatedRes = [...this.state.res, policydetail];
        const expiryDate = this.parseCustomDate(policydetail.policyexpirytdate);
        const today = new Date(currentDate);
        const noOfDaysForRenewal = this.findDayDifference(expiryDate, today) + 1;

        console.log('noOfDaysForRenewal', noOfDaysForRenewal);

        this.setState({ isActive: policydetail.policystatus.toLowerCase() === 'active' });
        this.setState({ currentSumInsured: policydetail.totalSumInsured || 0.00 });

        let policyStartDate = policydetail.policystartdate;
        let renewButton = false;
        let showSaveButton = false;
        let showRenewButton = false;


        if (noOfDaysForRenewal < 30) {
          policyStartDate = policydetail.policyexpirytdate;
        }

        if (noOfDaysForRenewal <= 31
          // && policydetail.productid !== 3
        ) {
          renewButton = true;
          showRenewButton = true;
        }

        if (this.state.isActive &&
          (this.state.loggedInUser.RoleName.toLowerCase() === 'insureradmin'
            || this.state.loggedInUser.RoleName.toLowerCase() === 'underwriter')) {
          showSaveButton = true;
        }
        else if (!this.state.isActive && this.state.loggedInUser.RoleName.toLowerCase() === 'broker') {
          showSaveButton = true;
        }
        else {
          showSaveButton = false;
        }

        // Aggregates
        let monthlyPremiumTotal = 0;
        let monthlyTotalPayment = 0;
        let sumInsuredTotal = 0;
        let prorataTotalTermPremium = 0;
        let prorataPremiumTotalForEdit = 0;
        let annualPremiumTotalForEdit = 0;
        let termPremiumTotalForEdit = 0;

        if ([3, 4, 5].includes(policydetail.productid)) {
          riskItems.forEach(item => {
            monthlyPremiumTotal += item.monthlypremium || 0;
            monthlyTotalPayment += item.monthlypremium || 0;
            sumInsuredTotal += item.suminsured || 0;
          });
          prorataTotalTermPremium = policydetail.proratatotaltermpremium || 0;
        } else {
          riskItems.forEach(item => {
            prorataPremiumTotalForEdit += item.prorata || 0;
            annualPremiumTotalForEdit += item.annualpremium || 0;
            termPremiumTotalForEdit += item.termpremium || 0;
          });
        }

        this.setState({ selectedInsurer: policydetail.insurerId });
        this.insurerChange(policydetail.insurerId);
        this.transactionDetails(policydetail.policynumber);

        this.setState({
          res: updatedRes,
          noOfDaysForRenewal,
          showRenewButton,
          showSaveButton,
          policyNumber: policydetail.policynumber,
          clientfirstname: customerdetail.clientfirstname,
          clientsurname: customerdetail.clientsurname,
          clientcontactnumber: customerdetail.clientcontactnumber,
          clientage: customerdetail.clientage,
          clientaddress1: customerdetail.clientaddress1,
          clientId: customerdetail.id,
          nationalid: customerdetail.nationalid,
          clientcorporatename: customerdetail.clientcorporatename,
          clientemailaddress: customerdetail.clientemailaddress,
          clientgender: customerdetail.clientgender,
          suburb: customerdetail.suburb,
          city: customerdetail.city,
          entitytype: customerdetail.entitytype,
          riskCoverFromApi: policydetail.policyriskcover,
          paymentterm: policydetail.paymentterms,
          policynumber: policydetail.policynumber,
          policyStatus: policydetail.policystatus,
          policyStartDate,
          policyexpirytdate: policydetail.policyexpirytdate,
          currency: policydetail.currency,
          productId: policydetail.productid,
          productName: policydetail.productname,
          policyriskcover: policydetail.policyriskcover,
          policyriskcoverid: policydetail.riskcoverid,
          grandtotalannualpremium: policydetail.grandtotalannualpremium,
          stampdutytermpremium: policydetail.stampdutytermpremium,
          newProduct: riskItems,
          data: [...this.state.data, ...riskItems], // Flatten riskItems here
          monthlyPremiumTotal,
          monthlyTotalPayment,
          sumInsuredTotal,
          prorataTotalTermPremium,
          prorataPremiumTotalForEdit,
          annualPremiumTotalForEdit,
          termPremiumTotalForEdit,
          renewButton,
          annualPremiumTotal: policydetail.totalannualpremium,
          termPremiumTotal: policydetail.totaltermpremium,
          // prorataPremiumTotal: policydetail.proratatotaltermpremium,
          brokerId: policydetail.brokerId,
          monthlyTermPayment: policydetail.monthlyTermPayment,
        });

        return apiRequest(
          `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetRiskItembyId/risk-item/${policydetail.riskcoverid}`,
          'GET',
        );
      })
        .catch(error => {
          console.error('Error in componentDidMount:', error);
          this.setState({ loading: false });
        });

      apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetGloabalList/${this.state.productId}`,
        'GET',
      )
        .then(response => {
          if (response.success && response.data) {
            const data = response.data.result;
            this.setState({
              stampDuty: data.mastersetting[0].stampduty,
              // reinsuranceLimit: data.mastersetting[0].reinsurancelimit,
              currencyList: data.currencylist,
            });
          } else {
            console.error('API Error:', response.error);
          }
        })
        .catch(error => console.error('Error fetching global list:', error))
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  }

  insurerChange = async (value) => {
    this.setState({ selectedInsurer: value });

    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIdProductId?productId=${this.state.productId}&insurerId=${value}`,
        'GET'
      );

      if (response.success && response.data?.insurerProduct) {
        const product = response.data.insurerProduct;

        this.setState({
          specificProductID: product.id,
          reinsuranceLimit: product.maxLimit,
          minimumPremium: product.minimumPremium,
          sumInsured: product.sumInsured, // ✅ Add this line
        });

        this.fetchTaxesByInsurer(value); // fetch taxes by insurer
      } else {
        console.error('API Error:', response.error);
      }
    } catch (error) {
      console.error('Request failed:', error);
    }

    this.getInsurers();
  };


  fetchTaxesByInsurer = async (insurerId) => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetTaxesByInsurerAndProductId/${insurerId}/${this.state.specificProductID}`,
        "GET"
      );
      console.log("RAW API Response:", res.data);
      const taxes = res?.data || [];
      if (taxes.length > 0) {
        const filteredTaxes = taxes;
        if (filteredTaxes.length > 0) {
          this.setState({ taxes: filteredTaxes });
        } else {
          this.setState({ taxes: [] });
          message.error("No tax data found for the selected product.");
        }
      } else {
        this.setState({ taxes: [] });
        message.error("No tax data found for the selected insurer.");
      }
    } catch (err) {
      this.setState({ taxes: [] });
    }
  };

  getInsurers = async () => {
    try {
      if (this.state.isInsurer) {
        const insurer = {
          id: this.state.selectedInsurer,
          firstName: this.state.InsurerFirstName,
          lastName: this.state.InsurerLastName,
        };
        this.setState({ insurerList: [insurer] });
      } else {
        const data = JSON.parse(localStorage.getItem('user'));
        let response;

        if (data?.role === '311' || data?.role === '303') {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurersWithAllowedBrokersOfProductByBrokerId/` +
            this.state.brokerId + '/' + this.state.productId,
            'GET',
          );
        } else {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurersWithAllowedBrokersByProduct/` +
            this.state.productId,
            'GET',
          );
        }

        if (response.success) {
          this.setState({ insurerList: response.data });
        } else {
          console.error('API Error:', response.error);
        }
      }
    } catch (error) {
      console.error('Request failed:', error);
    }

    // ✅ Fetch Risk Covers & Items
    apiRequest(
      `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskCoversByInsurerProductId/${this.state.specificProductID}`,
      'GET',
    )
      .then(response => {
        if (response.success && response.data?.length > 0) {
          const cover = response.data[0];
          const riskItem = cover?.riskItems?.[0]; // first risk item

          this.setState({
            riskCoverDrop: response.data,
            policyCoverValue: cover?.riskCoverName || '',
            riskItemName:
              riskItem?.riskItemName || 'Individual + Additional Family Members',
            loading: false,
          });
        } else {
          console.error('API Error:', response.error);
        }
      })
      .catch(error => console.error('Error fetching Cover list:', error));
  };

  componentWillUnmount() {
    localStorage.removeItem('clientId')
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.data !== this.state.data ||
      prevState.taxes !== this.state.taxes ||
      prevState.prorataPremiumTotalForEdit !== this.state.prorataPremiumTotalForEdit ||
      prevState.annualPremiumTotal !== this.state.annualPremiumTotal ||
      prevState.termPremiumTotal !== this.state.termPremiumTotal
    ) {
      this.updateGrandTotals();
    }
  }

updateGrandTotals = () => {
  const totals = {
    prorata: Number(this.state.prorataPremiumTotalForEdit) || 0,
    annualpremium: Number(this.state.annualPremiumTotal) || 0,
    termpremium: Number(this.state.termPremiumTotal) || 0,
  };

  const productName = (localStorage.getItem("productName") || "").toLowerCase();
  const isMotor = productName.includes("motor");
  const months = Number(this.state.paymentterm) || 12; // months used for prorating if needed

  // compute tax amounts per tax entry
  const taxAmounts = (this.state.taxes || [])
    .filter(tax => {
      // include government levy only for motor and matching private/commercial
      if ((tax.taxName || '').toLowerCase().includes("government levy")) {
        if (!isMotor) return false;
        if (this.state.entitytype === "Individual") {
          return (tax.taxName || '').toLowerCase().includes("private");
        } else if (this.state.entitytype === "Business") {
          return (tax.taxName || '').toLowerCase().includes("commercial");
        }
        return false;
      }
      return true;
    })
    .map(tax => {
      const taxName = (tax.taxName || '').toLowerCase();
      const rate = Number(tax.ratePercentage) || 0;
      let amounts = { prorata: 0, annualpremium: 0, termpremium: 0 };

      // Motor-specific government levy handled elsewhere above

      if (taxName.includes("stamp duty")) {
        // If tax.type exists and equals 'fixed amount', treat as fixed currency
        if ((tax.type || '').toLowerCase() === 'fixed amount') {
          // fixed amount: apply as given (annual = fixed amount),
          // term = fixed / 12 (monthly portion) OR prorate by months if required.
          amounts.annualpremium = rate;
          // termpremium computed as monthly portion; if paymentterm < 12, multiply monthly by months
          amounts.termpremium = +(rate / 12);
          // If you want to consider months (e.g., paymentterm months), uncomment:
          // amounts.termpremium = +(rate / 12 * (months/1));
        } else {
          // stamp duty as percentage of the totals (with cap)
          amounts.annualpremium = Math.min(totals.annualpremium * (rate / 100), 100000);
          amounts.termpremium = Math.min(totals.termpremium * (rate / 100), 100000);
        }
      } else if (isMotor && (taxName.includes("private") || taxName.includes("commercial"))) {
        // special motor levy logic (keeps previous behavior)
        const prorated = (rate / 12) * months;
        const levyValue = Math.max(prorated, 2);
        amounts = {
          prorata: 0,
          annualpremium: rate,
          termpremium: levyValue,
        };
      } else {
        // generic percentage tax
        amounts.annualpremium = totals.annualpremium * (rate / 100);
        amounts.termpremium = totals.termpremium * (rate / 100);
      }

      return { ...tax, amounts };
    });

  // sum up taxes
  const totalTaxAnnual = taxAmounts.reduce((sum, t) => sum + (Number(t.amounts.annualpremium) || 0), 0);
  const totalTaxTerm = taxAmounts.reduce((sum, t) => sum + (Number(t.amounts.termpremium) || 0), 0);
debugger;
  const grandTotals = {
    annualpremium: totals.annualpremium + totalTaxAnnual,
    termpremium: totals.termpremium + parseFloat(totalTaxTerm.toFixed(2)),
  };

  // round to 2 decimals for display
  grandTotals.annualpremium = grandTotals.annualpremium;
  grandTotals.termpremium = grandTotals.termpremium;
debugger;
  this.setState({ grandTotals });
};



  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }

  onInputchange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // Redirecting to another model where client can add customer to the database
  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    })
    this.setState({ visible: true })
  }

  // Functions for Modal functioanlity to add customers
  setVisible() {
    this.setState({ visible: true })
  }
  setVisibleFalse() {
    this.setState({ visible: false })
  }

  // Function for search functionality
  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    })
  }

  ShowHideCorporateName(value) {
    this.setState({ entitytype: value })

  }
  DobFcp(date, datestring) {
    var dd = this.state.policyriskcover
    // debugger
    if (this.state.policyriskcover.length > 0) {
      var a = moment(new Date())
      var b = moment(date)
      var daysOld = a.diff(b, 'days')
      var monthsOld = a.diff(b, 'months')
      var yearsOld = a.diff(b, 'years') // 1

      var agesuffix =
        yearsOld == 1
          ? 'year'
          : yearsOld > 1
            ? 'years'
            : monthsOld == 1
              ? 'month'
              : monthsOld > 1
                ? 'months'
                : daysOld == 1
                  ? 'day'
                  : 'days'
      if (yearsOld > 0) {
        this.setState({ ageFcp: yearsOld.toString() + ' ' + agesuffix })
      } else if (monthsOld > 0) {
        this.setState({ ageFcp: monthsOld.toString() + ' ' + agesuffix })
      } else {
        this.setState({ ageFcp: daysOld.toString() + ' ' + agesuffix })
      }
      for (let i = 0; i < this.state.riskItemList.length; i++) {
        const item = this.state.riskItemList[i]
        const rname = item?.riskitemname

        if (!rname || typeof rname !== 'string') continue

        const range = rname.replace(/[^\d.]/g, '')
        let Range1 = 0
        let Range2 = 0

        if (range.length > 3) {
          Range1 = parseInt(range.substring(0, 2))
          Range2 = parseInt(range.slice(-2))
        } else if (range.length === 3) {
          Range1 = parseInt(range.substring(0, 1))
          Range2 = parseInt(range.slice(-2))
          if (yearsOld === 0) {
            this.setState({ rate: item.ratepercentage })
            break
          }
        }

        if (yearsOld > 0 && yearsOld < Range2 && yearsOld > Range1) {
          this.setState({ rate: item.ratepercentage })
          break
        }
      }
    } else {
      datestring = null
      message.warning('Please select Policy Cover')
    }
  }

  closeModal(e) {
    this.setState({
      setOpen: false,
    })
    window.location.href = '/endorsedpolicy'
  }

  // function for submit add policy 22 march 22 john
  formatExpiryDate(input) {
    let dateObj;

    // Try parsing normally
    dateObj = new Date(input);

    // If date is invalid and format is "DD-MM-YYYY HH:mm:ss"
    if (isNaN(dateObj.getTime()) && /^\d{2}-\d{2}-\d{4}/.test(input)) {
      const [datePart, timePart = '00:00:00'] = input.split(' ');
      const [day, month, year] = datePart.split('-');
      dateObj = new Date(`${year}-${month}-${day}T${timePart}`);
    }

    // If still invalid, return null
    if (isNaN(dateObj.getTime())) return null;

    const monthsToAdd = parseInt(this.state.policyDuration, 10) || 0;
    dateObj.setMonth(dateObj.getMonth() + monthsToAdd);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = '00';
    const minutes = '00';
    const seconds = '00';

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  formatStartDate(input) {
    let dateObj;

    // Try parsing normally
    dateObj = new Date(input);

    // If date is invalid and format is "DD-MM-YYYY HH:mm:ss"
    if (isNaN(dateObj.getTime()) && /^\d{2}-\d{2}-\d{4}/.test(input)) {
      const [datePart, timePart = '00:00:00'] = input.split(' ');
      const [day, month, year] = datePart.split('-');
      dateObj = new Date(`${year}-${month}-${day}T${timePart}`);
    }

    // If still invalid, return null
    if (isNaN(dateObj.getTime())) return null;

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = '00';
    const minutes = '00';
    const seconds = '00';

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  handleEditSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }

      try {
        const editedRecord = this.state.data.find(
          item => item.policyriskitemid === this.state.editingRecordId
        );

        if (!editedRecord) {
          message.error('Record not found for editing');
          return;
        }

        // Calculate dates
        const start_date = new Date(this.state.riskItemStartDate);
        const end_date = new Date(this.state.policyexpirytdate);
        const Noofdays = this.findDayDifference(start_date, end_date);

        // Calculate premiums
        let annualpremium = roundvalue((values.sumInsured / 100) * this.state.rate);

        let termpremium = 0;
        if (this.state.monthlyTermPayment) {
          termpremium = (values.sumInsured / 100) * this.state.rate / parseInt(this.state.policyDuration);
        } else {
          if (this.state.paymentterm == 3) termpremium = ((values.sumInsured / 100) * this.state.rate) / 4;
          else if (this.state.paymentterm == 4) termpremium = ((values.sumInsured / 100) * this.state.rate) / 3;
          else if (this.state.paymentterm == 6) termpremium = ((values.sumInsured / 100) * this.state.rate) / 2;
          else if (this.state.paymentterm == 12) termpremium = (values.sumInsured / 100) * this.state.rate;
        }

        const minPremium = Number(this.state.minimumPremium || 0);
        if (annualpremium < minPremium) annualpremium = minPremium;
        if (termpremium < minPremium) termpremium = minPremium;

        const overrideNote =
          annualpremium < minPremium || termpremium < minPremium
            ? `Applied minimum premium $${minPremium}`
            : '';
        this.setState({ overrideNotes: overrideNote });

        const prorata = roundvalue((values.sumInsured / 100) * this.state.rate * (Noofdays / 365));

        const riskstartdate = new Date(this.state.riskItemStartDate);
        const riskenddate = new Date(this.state.policyexpirytdate);

        const updatedRiskItem = {
          ...editedRecord,
          address: values.address,
          suminsured: parseInt(values.sumInsured),
          rate: this.state.rate,
          annualpremium,
          termpremium,
          prorata,
          policy_cover_id: this.state.riskcoverid,
          riskitemid: this.state.riskitemid.toString(),
          riskitemname: this.state.riskitemfortable,
          itempstartdate: riskstartdate.toGMTString(),
          itempexpirydate: riskenddate.toGMTString(),
          monthlypremium: productNameInLocalStorage === 'LEGAL INSURANCE' ? this.state.rate : 0,

        };

        const updatedRiskItemList = this.state.res[0].riskitemdetails.map(item =>
          item.policyriskitemid === updatedRiskItem.policyriskitemid ? updatedRiskItem : item
        );

        const updatedData = this.state.data.map(item =>
          item.policyriskitemid === updatedRiskItem.policyriskitemid ? updatedRiskItem : item
        );

        // Recalculate totals
        let totalMonthlyPremium = 0;
        let annual_premium = 0;
        let term_premium = 0;
        let pro_rata = 0;
        let TotalSumInsured = 0;

        updatedRiskItemList.forEach(item => {
          pro_rata += item.prorata;
          annual_premium += item.annualpremium;
          term_premium += item.termpremium;
          totalMonthlyPremium += parseInt(item.monthlypremium);
          TotalSumInsured += parseInt(item.suminsured);
        });

        // Update state
        this.setState({
          res: [{ ...this.state.res[0], riskitemdetails: updatedRiskItemList }],
          data: updatedData,
          monthlyTotalPayment: totalMonthlyPremium,
          prorataPremiumTotalForEdit: pro_rata,
          annualPremiumTotalForEdit: annual_premium,
          termPremiumTotalForEdit: term_premium,
          annualPremiumTotal: roundvalue(annual_premium),
          termPremiumTotal: roundvalue(term_premium),
          editingRecordId: null,
          sumInsuredTotal: TotalSumInsured,
        });

        this.props.form.resetFields(['policyCover', 'riskItem', 'address', 'sumInsured']);
        this.setState({
          riskItemValue: 'Select',
          policyCoverValue: 'Select',
          monthlyPaymentValues: 0,
          addressValue: '',
          sumInsuredValue: 0,
          rate: 0,
          Minimum_rate: 0,
        });

        message.success('Risk item updated successfully!');
      } catch (error) {
        console.error('Error updating risk item:', error);
        message.error('Failed to update risk item');
      }
    });
  };


  submitpolicy = async e => {
    let apiurl
    e.preventDefault()
    const expDate = this.parseCustomDate(this.state.policyexpirytdate);
    const today = new Date(this.state.currentDate);
    const Days = this.findDayDifference(expDate, today) + 1;

    if (this.state.data.length === 0) {
      message.error('Please add at least one risk item.')
      this.setState({ loading: false })
      return
    }
    const originalDate = this.state.policyexpirytdate;
    if (Days <= 45) {
      apiurl = process.env.REACT_APP_BASE_URL + '/Policy/renewPolicy'
      let totalannualpremium = roundvalue(this.state.annualPremiumTotal)
      if (this.parseCustomDate(this.state.policyexpirytdate) > new Date(this.state.currentDate + 1)) {
        console.log("data being sent to backend", this.state.res);


        this.state.res[0].policyriskcover = this.state.policyriskcover
        this.state.res[0].policyStartDate = this.formatStartDate(today)
        this.state.res[0].policyexpirytdate = this.formatExpiryDate(originalDate)
        this.state.res[0].paymentterms = this.state.paymentterm
        this.state.res[0].parentpolicyid = this.state.clientId
        this.state.res[0].createddate = new Date()
        this.state.res[0].modifieddate = new Date()
        this.state.res[0].grandtotalannualpremium = this.state.annualPremiumTotalForEdit
        this.state.res[0].grandtotaltermpremium = this.state.termPremiumTotalForEdit
        this.state.res[0].proratatotaltermpremium = roundvalue(this.state.prorataPremiumTotalForEdit)
        this.state.res[0].nationalid = this.state.nationalid

        let postData = {}
        if (productNameInLocalStorage === 'LEGAL INSURANCE') {
          let stampDutyForLegalProduct = parseFloat((this.state.monthlyTotalPayment / 100) * this.state.stampDuty)
          let total = parseFloat(this.state.monthlyTotalPayment) + parseFloat(stampDutyForLegalProduct)
          postData = {
            grandtotalannualpremium: parseFloat(total).toFixed(2),
            proratatotaltermpremium: parseFloat(this.state.monthlyTotalPayment).toFixed(2),
            stampdutytermpremium: parseFloat(stampDutyForLegalProduct).toFixed(2),
            grandtotaltermpremium: 0,
          }
        }
        let bodyData = { ...this.state.res[0], ...postData }

        console.log(bodyData);
        const response = await apiRequest(apiurl, 'POST', bodyData)

        if (response.success) {
          message.success('Policy renewed successfully !!')
          window.location.href = `/payment/${response.data.policyid}`
        } else {
          message.error('Policy renewal failed')
        }
      } else {
        message.warning('Policy end date should be greater than current date')
      }
    } else {
      apiurl = process.env.REACT_APP_BASE_URL + '/Policy/endorsepolicy'
      const customerDetails = {
        CustomerName: this.state.clientfirstname,
        CustomerSurname: this.state.clientsurname,
        Mobile: this.state.clientcontactnumber,
        Age: this.state.clientage.toString(),
        Address: this.state.clientaddress1,
        CorporateName: this.state.clientcorporatename,
        emailAddress: this.state.clientemailaddress,
        Gender: this.state.clientgender,
        Suburb: this.state.suburb,
        city: this.state.city,
        EntityType: this.state.entitytype,
        NationalID: this.state.nationalid,
      }

      this.state.res[0].customersdetails = customerDetails
      this.state.res[0].policyriskcover = this.state.policyriskcover
      this.state.res[0].riskcoverid = this.state.policyriskcoverid
      this.state.res[0].policyexpirytdate = this.formatExpiryDate(originalDate)
      this.state.res[0].paymentterms = this.state.paymentterm
      this.state.res[0].parentpolicyid = this.state.clientId
      this.state.res[0].createddate = new Date()
      this.state.res[0].modifieddate = new Date()
      this.state.res[0].grandtotalannualpremium = this.state.grandTotals.annualpremium
      this.state.res[0].grandtotaltermpremium = this.state.grandTotals.termpremium
      this.state.res[0].proratatotaltermpremium = roundvalue(this.state.prorataPremiumTotalForEdit)
      this.state.res[0].totalannualpremium = (12 / parseInt(this.state.paymentterm)) * this.state.res[0].riskitemdetails.reduce((acc, item) => acc + parseFloat(item.termpremium), 0)
      this.state.res[0].totaltermpremium = this.state.res[0].riskitemdetails.reduce((acc, item) => acc + parseFloat(item.termpremium), 0)
      this.state.res[0].totalSumInsured = this.state.res[0].riskitemdetails.reduce((acc, item) => acc + parseFloat(item.suminsured), 0)

      let postData = this.state.res[0]

      if (productNameInLocalStorage === 'LEGAL INSURANCE') {
        let stampDutyForLegalProduct = parseFloat((this.state.monthlyTotalPayment / 100) * this.state.stampDuty)
        let total = parseFloat(this.state.monthlyTotalPayment) + parseFloat(stampDutyForLegalProduct)
        postData = {
          ...postData,
          grandtotalannualpremium: parseFloat(total).toFixed(2),
          proratatotaltermpremium: parseFloat(this.state.monthlyTotalPayment).toFixed(2),
          stampdutytermpremium: parseFloat(stampDutyForLegalProduct).toFixed(2),
        }
      }

      const response = await apiRequest(apiurl, 'POST', postData)

      if (response.success) {
        message.success('Policy updated successfully !!')
        window.location.href = '/policies'
      }
    }
  }


  updateInput() {
    const current = []
    fetch(process.env.REACT_APP_BASE_URL + '/GetClientDetailsbyid/1')
      .then(response => response.json())
      .then(data => current.push(data.result))
    const userRoles = JSON.parse(localStorage.getItem('roles'))
  }

  riskitem(value) {
    this.setState({ cellphone: false })
    this.setState({ riskitemid: value })
    for (let i = 0; i < this.state.riskItemList.length; i++) {
      if (value === this.state.riskItemList[i].riskItemId) {
        this.setState({ Minimum_rate: this.state.riskItemList[i].ratePercentage })
        this.state.riskitemfortable = this.state.riskItemList[i].riskItemName

        if (this.state.riskItemList[i].riskItemName === 'Cellphone') {
          this.setState({ cellphone: true })
        }
        if (
          this.state.riskItemList[i].riskItemName === 'Jewellery' ||
          this.state.riskItemList[i].riskItemName === 'Art'
        ) {
          this.state.coverType = 'Agreed Value'
        } else {
          this.state.coverType = 'Sum Insured'
        }
      }
    }
    this.setState({ riskItemValue: value })
  }

  covertype(value) {
    this.state.coverType = value
  }

  findDayDifference(date1, date2) {
    // always round down
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }
  handleSubmitWithId = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }

      const start_date = this.state.riskItemStartDate;
      const end_date = this.state.policyexpirytdate;
      const Noofdays = this.findDayDifference(new Date(start_date), new Date(end_date));

      const riskstartdate = new Date(start_date);
      const riskenddate = new Date(end_date);

      let annualpremium = roundvalue((values.sumInsured / 100) * this.state.rate);
      let termpremium = 0;

      if (this.state.monthlyTermPayment) {
        termpremium = ((values.sumInsured / 100) * this.state.rate) / parseInt(this.state.policyDuration);
      } else {
        switch (this.state.paymentterm) {
          case 3: termpremium = ((values.sumInsured / 100) * this.state.rate) / 4; break;
          case 4: termpremium = ((values.sumInsured / 100) * this.state.rate) / 3; break;
          case 6: termpremium = ((values.sumInsured / 100) * this.state.rate) / 2; break;
          case 12: termpremium = ((values.sumInsured / 100) * this.state.rate); break;
          default: termpremium = 0; break;
        }
      }

      // Apply minimum premium
      const minPremium = this.state.minimumPremium || 0;
      if (annualpremium < minPremium) annualpremium = minPremium;
      if (termpremium < minPremium) termpremium = minPremium;

      const overrideNote = (annualpremium < minPremium || termpremium < minPremium)
        ? `Applied minimum premium $${minPremium}`
        : '';

      this.setState({ overrideNotes: overrideNote });

      const prorata = roundvalue(annualpremium * (Noofdays / 365));
      const productName = localStorage.getItem('productname');

      // Calculate refund if editing existing item
      let refund = 0;
      if (this.state.editingRecordId != null) {
        const prevItem = this.state.data.find(
          item => item.policyriskitemid === this.state.editingRecordId
        );
        if (prevItem && prevItem.suminsured > Number(values.sumInsured)) {
          const excess = prevItem.suminsured - Number(values.sumInsured);
          refund = roundvalue((excess / 100) * this.state.rate); // or prorata if needed
        }
      }

      // Prepare risk item object
      let newProduct = {
        id: Date.now(),
        address: values.address,
        suminsured: Number(values.sumInsured),
        rate: this.state.rate,
        annualpremium,
        termpremium,
        prorata,
        refund: this.state.editingRecordId != null ? refund : 0, //  refund here
        policynumber: this.state.policynumber,
        policyid: this.state.res[0]?.policyid,
        policy_cover: this.state.policyriskcover,
        policy_cover_id: this.state.riskcoverid,
        policyriskitemid: this.state.editingRecordId || 0,
        riskitemid: this.state.riskitemid?.toString() || values.riskItem,
        riskitemname: this.state.riskitemfortable,
        monthlypremium: productName === 'LEGAL INSURANCE' ? this.state.rate : 0,
        itempstartdate: riskstartdate.toGMTString(),
        itempexpirydate: riskenddate.toGMTString(),
      };

      if (productName === 'LEGAL INSURANCE') {
        newProduct = {
          ...newProduct,
          age: '',
          gender: '',
          membername: '',
          suminsured: 0,
          annualpremium: 0,
          termpremium: 0,
          prorata: 0,
        };
      }

      // Add or update risk item
      if (this.state.editingRecordId != null) {
        this.setState(prevState => {
          const updatedRes = [...prevState.res];
          const updatedPolicy = { ...updatedRes[0] };
          const updatedRiskItemDetails = (updatedPolicy.riskitemdetails || []).map(item =>
            item.policyriskitemid === prevState.editingRecordId
              ? { ...item, ...newProduct, policyriskitemid: prevState.editingRecordId }
              : item
          );
          updatedPolicy.riskitemdetails = updatedRiskItemDetails;
          updatedRes[0] = updatedPolicy;

          // Recalculate totals
          const totalMonthlyPremium = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.monthlypremium || 0), 0);
          const totalProRata = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.prorata || 0), 0);
          const totalAnnual = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.annualpremium || 0), 0);
          const totalTerm = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.termpremium || 0), 0);

          return {
            res: updatedRes,
            data: updatedRiskItemDetails,
            monthlyTotalPayment: totalMonthlyPremium,
            monthlyPremiumTotal: totalMonthlyPremium,
            prorataPremiumTotalForEdit: totalProRata,
            annualPremiumTotalForEdit: totalAnnual,
            termPremiumTotalForEdit: totalTerm,
            annualPremiumTotal: totalAnnual,
            termPremiumTotal: totalTerm,
            editingRecordId: null,
          };
        }, () => {
          this.props.form.resetFields(['policyCover', 'riskItem', 'address', 'sumInsured']);
          this.setState({
            riskItemValue: 'Select',
            policyCoverValue: 'Select',
            monthlyPaymentValues: 0,
            addressValue: '',
            sumInsuredValue: 0,
            rate: 0,
            Minimum_rate: 0,
          });
          message.success('Risk item updated successfully!');
        });
      } else {
        // Add new item
        this.setState(prevState => {
          const updatedRes = [...prevState.res];
          const updatedPolicy = { ...updatedRes[0] };
          const updatedRiskItemDetails = [...(updatedPolicy.riskitemdetails || []), newProduct];
          updatedPolicy.riskitemdetails = updatedRiskItemDetails;
          updatedRes[0] = updatedPolicy;

          // Recalculate totals
          const totalMonthlyPremium = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.monthlypremium || 0), 0);
          const totalProRata = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.prorata || 0), 0);
          const totalAnnual = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.annualpremium || 0), 0);
          const totalTerm = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.termpremium || 0), 0);

          return {
            res: updatedRes,
            data: updatedRiskItemDetails,
            monthlyTotalPayment: totalMonthlyPremium,
            monthlyPremiumTotal: totalMonthlyPremium,
            prorataPremiumTotalForEdit: totalProRata,
            annualPremiumTotalForEdit: totalAnnual,
            termPremiumTotalForEdit: totalTerm,
            annualPremiumTotal: totalAnnual,
            termPremiumTotal: totalTerm,
          };
        }, () => {
          console.log("Updated riskitemdetails:", this.state.res[0]?.riskitemdetails);
          console.log("Data list synced:", this.state.data);
        });
      }
    });
  };


  showAllErrorMessages = (errorObj) => {

    if (!errorObj || typeof errorObj !== 'object') return;

    const errorEntries = Object.entries(errorObj);

    errorEntries.forEach(([fieldName, fieldData], index) => {
      const errors = fieldData?.errors;
      if (Array.isArray(errors)) {
        errors.forEach((err, errIndex) => {
          const delay = 3000 * (index + errIndex); // stagger per field and message
          setTimeout(() => {
            if (err?.message) {
              message.error(err.message);
            }
          }, delay);
        });
      }
    });
  };

  handleSubmit = e => {

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }

      const totalSumInsured = this.state.sumInsuredTotal + Number(values.sumInsured);
      if (totalSumInsured > this.state.reinsuranceLimit) {
        message.warning('Total Sum Insured exceeds reinsurance limit');

      }

      // update sum insured total
      this.setState(prevState => ({
        sumInsuredTotal: prevState.sumInsuredTotal + Number(values.sumInsured)
      }));

      const start_date = this.state.riskItemStartDate;
      const end_date = this.state.policyexpirytdate;
      const Noofdays = this.findDayDifference(new Date(start_date), new Date(end_date));

      const riskstartdate = new Date(start_date);
      const riskenddate = new Date(end_date);

      let annualpremium = roundvalue((values.sumInsured / 100) * this.state.rate);
      let termpremium = '0.0';

      if (this.state.monthlyTermPayment) {
        termpremium = ((values.sumInsured / 100) * this.state.rate) / parseInt(this.state.policyDuration);
      } else {
        if (this.state.paymentterm == 3) {
          termpremium = ((values.sumInsured / 100) * this.state.rate) / 4;
        } else if (this.state.paymentterm == 4) {
          termpremium = ((values.sumInsured / 100) * this.state.rate) / 3;
        } else if (this.state.paymentterm == 6) {
          termpremium = ((values.sumInsured / 100) * this.state.rate) / 2;
        } else if (this.state.paymentterm == 12) {
          termpremium = ((values.sumInsured / 100) * this.state.rate);
        }
      }

      // Apply minimum premium
      const minPremium = this.state.minimumPremium || 0;
      if (annualpremium < minPremium) annualpremium = minPremium;
      if (termpremium < minPremium) termpremium = minPremium;

      const overrideNote = (annualpremium < minPremium || termpremium < minPremium)
        ? `Applied minimum premium $${minPremium}`
        : '';

      this.setState({ overrideNotes: overrideNote });

      const prorata = roundvalue(annualpremium * (Noofdays / 365));
      const productName = localStorage.getItem('productname');
      // Calculate refund if sum insured is less than original
      let refundAmount = 0;
      const originalRiskItem = this.state.newProduct.filter(x => x.riskitemid == values.riskItem)[0];
      const currentRiskItem = values;
      if (originalRiskItem.suminsured > currentRiskItem.sumInsured) {
        refundAmount = originalRiskItem.suminsured - currentRiskItem.sumInsured;
      }

      let newProduct = {
        id: originalRiskItem.id,
        address: values.address,
        suminsured: values.sumInsured,
        rate: this.state.rate,
        annualpremium,
        termpremium,
        policynumber: this.state.policynumber,
        policyid: this.state.res[0]?.policyid,
        policy_cover: this.state.policyriskcover,
        policy_cover_id: this.state.riskcoverid,
        policyriskitemid: 0,
        riskitemid: this.state.riskitemid?.toString() === '' ? values.riskItem : this.state.riskitemid?.toString(),
        riskitemname: this.state.riskitemfortable,
        policyquotatonid: this.state.res[0]?.id,
        prorata,
        itempstartdate: riskstartdate.toGMTString(),
        itempexpirydate: riskenddate.toGMTString(),
        monthlypremium: productName === 'LEGAL INSURANCE' ? this.state.rate : 0,
        refund: refundAmount,
      };

      // Calculate refund if previous sum insured was higher


      // If editingRecordId is set, update the existing record instead of adding new
      if (this.state.editingRecordId != null) {
        this.setState(prevState => {
          const updatedRes = [...prevState.res];
          const updatedPolicy = { ...updatedRes[0] };
          const updatedRiskItemDetails = (updatedPolicy.riskitemdetails || []).map(item =>
            item.policyriskitemid === prevState.editingRecordId
              ? { ...item, ...newProduct, policyriskitemid: prevState.editingRecordId }
              : item
          );
          updatedPolicy.riskitemdetails = updatedRiskItemDetails;
          updatedRes[0] = updatedPolicy;

          // Totals
          const totalMonthlyPremium = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.monthlypremium || 0), 0);
          const totalProRata = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.prorata || 0), 0);
          const totalAnnual = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.annualpremium || 0), 0);
          const totalTerm = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.termpremium || 0), 0);

          return {
            res: updatedRes,
            data: updatedRiskItemDetails,
            monthlyTotalPayment: totalMonthlyPremium,
            monthlyPremiumTotal: totalMonthlyPremium,
            prorataPremiumTotalForEdit: totalProRata,
            annualPremiumTotalForEdit: totalAnnual,
            termPremiumTotalForEdit: totalTerm,
            annualPremiumTotal: totalAnnual,
            termPremiumTotal: totalTerm,
            editingRecordId: null, // clear editing state
          };
        }, () => {
          this.props.form.resetFields([
            'policyCover',
            'riskItem',
            'address',
            'sumInsured',
          ]);
          this.setState({
            riskItemValue: 'Select',
            policyCoverValue: 'Select',
            monthlyPaymentValues: 0,
            addressValue: '',
            sumInsuredValue: 0,
            rate: 0,
            Minimum_rate: 0,
          });
          message.success('Risk item updated successfully!');
        });
      } else {
        // Add new item as before
        this.setState(prevState => {
          const updatedRes = [...prevState.res];
          const updatedPolicy = { ...updatedRes[0] };
          const updatedRiskItemDetails = [...(updatedPolicy.riskitemdetails || []), newProduct];
          updatedPolicy.riskitemdetails = updatedRiskItemDetails;
          updatedRes[0] = updatedPolicy;

          // Totals
          const totalMonthlyPremium = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.monthlypremium || 0), 0);
          const totalProRata = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.prorata || 0), 0);
          const totalAnnual = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.annualpremium || 0), 0);
          const totalTerm = updatedRiskItemDetails.reduce((acc, item) => acc + parseFloat(item.termpremium || 0), 0);

          return {
            res: updatedRes,
            data: updatedRiskItemDetails, // 👈 always sync with riskitemdetails
            monthlyTotalPayment: totalMonthlyPremium,
            monthlyPremiumTotal: totalMonthlyPremium,
            prorataPremiumTotalForEdit: totalProRata,
            annualPremiumTotalForEdit: totalAnnual,
            termPremiumTotalForEdit: totalTerm,
            annualPremiumTotal: totalAnnual,
            termPremiumTotal: totalTerm,
          };
        }, () => {
          console.log("Updated riskitemdetails:", this.state.res[0]?.riskitemdetails);
          console.log("Data list synced:", this.state.data);
        });
      }
    });
  }


  handleSubmitForFCP = e => {
    e.preventDefault()

    const { res, data, riskItemStartDate, rate, policyexpirytdate,
      riskitemid, riskitemfortable, ageFcp,
      policyriskcover, riskcoverid, policynumber } = this.state

    let lastIndex = res[0]?.riskitemdetails?.length || 0
    let lastIndexId = res[0]?.riskitemdetails?.[lastIndex - 1]?.id || 0

    this.props.form.validateFields((err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }
      if (!err) {
        const riskstartdate = new Date(riskItemStartDate)
        const totalSumInsured = this.state.sumInsuredTotal + Number(values.sumInsured)
        if (totalSumInsured > this.state.reinsuranceLimit) {
          message.warning('Total Sum Insured exceeds reinsurance limit')

        }
        this.setState(prevState => ({
          sumInsuredTotal: prevState.sumInsuredTotal + Number(values.sumInsured)
        }));
        let sum_insured = values.sumInsured > 0 ? values.sumInsured / 1000 : 0
        let monthly_pre = roundvalue(sum_insured * rate)

        // const Noofdays = this.findDayDifference(
        //   new Date(riskItemStartDate),
        //   new Date(policyexpirytdate)
        // )

        const expiryDate = this.parseCustomDate(policyexpirytdate);
        const Noofdays = this.findDayDifference(expiryDate, riskItemStartDate) + 1;

        const annualpremium = roundvalue((values.sumInsured / 100) * rate)

        let termpremium = 0;
        if (this.state.monthlyTermPayment) {
          termpremium =
            ((values.sumInsured / 100) * this.state.rate) / parseInt(this.state.policyDuration)
        } else {
          if (this.state.paymentterm === 3) {
            termpremium =
              ((values.sumInsured / 100) * this.state.rate) / 4
          } else if (this.state.paymentterm === 4) {
            termpremium =
              ((values.sumInsured / 100) * this.state.rate) / 3
          } else if (this.state.paymentterm === 6) {
            termpremium =
              ((values.sumInsured / 100) * this.state.rate) / 2
          } else if (this.state.paymentterm === 12) {
            termpremium =
              ((values.sumInsured / 100) * this.state.rate)
          }
        }
        // const termpremium = roundvalue(annualpremium / this.state.paymentterm)
        const prorata = roundvalue((values.sumInsured / 100) * rate * (Noofdays / 365))

        const newProduct = {
          riskitemid: riskitemid.toString(),
          riskitemname: riskitemfortable,
          rate: rate,
          gender: values.gender,
          membername: values.name,
          relationship: values.relation,
          suminsured: values.sumInsured || 0,
          premiumfactor: sum_insured,
          monthlypremium: monthly_pre,
          age: ageFcp,
          itempstartdate: riskstartdate.toGMTString(),
          // `${riskstartdate.getFullYear()}-${riskstartdate.getMonth() + 1}-${riskstartdate.getDate()}`,
          policy_cover: policyriskcover,
          policy_cover_id: riskcoverid,
          address: '',
          policynumber: policynumber,
          policyid: res[0].policyid,
          grand_total: 0,
          annualpremium: annualpremium,
          policyriskitemid: 0,
          termpremium: termpremium,
          prorata: prorata,
          policyquotatonid: 0,
          itempexpirydate: '',
        }

        // Push new product into data
        const updatedData = [...this.state.data, newProduct]

        // Recalculate totals
        let sumInsuredTotal = 0
        let monthlyPremiumTotal = 0
        let annual_premium = 0
        let term_premium = 0
        let pro_rata = 0

        updatedData.forEach(item => {
          sumInsuredTotal += item.suminsured
          monthlyPremiumTotal += item.monthlypremium
          annual_premium += item.annualpremium
          term_premium += item.termpremium
          pro_rata += item.prorata
        })
        const { appliedAnnualPremium, appliedTermPremium } = this.applyMinimumPremium(
          annual_premium,
          term_premium,
        );
        this.setState({
          data: updatedData,
          newProduct,
          sumInsuredTotalFCP: roundvalue(sumInsuredTotal),
          monthlyPremiumTotal: roundvalue(monthlyPremiumTotal),
          prorataPremiumTotalForEdit: roundvalue(pro_rata),
          annualPremiumTotalForEdit: roundvalue(appliedAnnualPremium),
          termPremiumTotalForEdit: roundvalue(appliedTermPremium),
          // prorataPremiumTotal: roundvalue(pro_rata),
          annualPremiumTotal: roundvalue(appliedAnnualPremium),
          termPremiumTotal: roundvalue(appliedTermPremium),
        })
      }
    })
  }


  startdateChange(date, datestring) {
    if (datestring === '') {
      message.warning('Start date cannot be empty')
    } else if (new Date(datestring) >= new Date(this.state.currentDate)) {
      this.setState({ policyStartDate: new Date(datestring) })
      var year = new Date(datestring).getFullYear()
      var month = new Date(datestring).getMonth()
      var day = new Date(datestring).getDate()
      var Newdate = new Date(year + 1, month, day)
      this.setState({ policyexpirytdate: Newdate })
    } else {
      message.warning('Start date cannot be smaller than Current Date')
    }
  }

  enddateChange(date, datestring) {
    if (datestring === '') {
      message.warning('End date cannot be null')
    } else {
      if (new Date(this.state.policyStartDate) < new Date(datestring)) {
        this.setState({ policyexpirytdate: new Date(datestring) })
      } else {
        message.error('Invalid Duration ')
      }
    }
  }
  startdateChangeRiskItem(date, datestring) {
    if (datestring === '') {
      message.warning('Risk item start date cannot be null')
    } else {
      if (new Date(this.state.policyexpirytdate) < new Date(datestring)) {
        message.error('Invalid Date')
      } else {
        this.setState({ riskItemStartDate: datestring })
      }
    }
  }

  SetRisKItemDataByStartDate(datestring) {
    let term_premium = '0.0'
    let prorata = '0.0'
    var date = this.state.policyEndDate

    var Noofdays = this.findDayDifference(
      new Date(datestring),
      new Date(this.state.policyexpirytdate),
    )
    Noofdays = Noofdays + 1

    let ctprorataPremiumTotal = 0
    let cttermPremiumTotal = 0
    let ctannualPremiumTotal = 0

    for (let i = 0; i < this.state.data[0].length; i++) {
      const annual = (this.state.data[0][i].rate / 100) * this.state.data[0][i].suminsured;
      const term = annual / 3;


      const { appliedAnnualPremium, appliedTermPremium } = this.applyMinimumPremium(annual, term);

      this.state.data[0][i].annualpremium = appliedAnnualPremium;
      this.state.data[0][i].termpremium = appliedTermPremium;


      this.state.data[0][i].prorata = roundvalue(
        ((this.state.data[0][i].suminsured * this.state.data[0][i].rate) / 100) *
        Noofdays / 365
      );
    }


    for (let i = 0; i < this.state.data[0].length; i++) {
      ctprorataPremiumTotal =
        this.state.data[0][i].prorata + ctprorataPremiumTotal
      cttermPremiumTotal =
        this.state.data[0][i].termpremium + cttermPremiumTotal
      ctannualPremiumTotal =
        this.state.data[0][i].annualpremium + ctannualPremiumTotal
    }

    this.setState({ prorataPremiumTotalForEdit: ctprorataPremiumTotal })
    this.setState({ termPremiumTotalForEdit: cttermPremiumTotal })
    this.setState({ annualPremiumTotalForEdit: ctannualPremiumTotal })
  }

  SetRisKItemDataByEndDate(datestring) {
    let term_premium = '0.0'
    let prorata = '0.0'

    var Noofdays = this.findDayDifference(
      new Date(this.state.policyStartDate),
      new Date(datestring),
    )
    Noofdays = Noofdays + 1

    let ctprorataPremiumTotal = 0
    let cttermPremiumTotal = 0
    let ctannualPremiumTotal = 0

    for (let i = 0; i < this.state.data[0].length; i++) {
      const annual = (this.state.data[0][i].rate / 100) * this.state.data[0][i].suminsured;
      const term = annual / 3;

      // Apply minimum premium
      const { appliedAnnualPremium, appliedTermPremium } = this.applyMinimumPremium(annual, term);

      this.state.data[0][i].annualpremium = appliedAnnualPremium;
      this.state.data[0][i].termpremium = appliedTermPremium;

      // Keep prorata as it is
      this.state.data[0][i].prorata = roundvalue(
        ((this.state.data[0][i].suminsured * this.state.data[0][i].rate) / 100) *
        Noofdays / 365
      );
    }


    for (let i = 0; i < this.state.data[0].length; i++) {
      ctprorataPremiumTotal =
        this.state.data[0][i].prorata + ctprorataPremiumTotal
      cttermPremiumTotal =
        this.state.data[0][i].termpremium + cttermPremiumTotal
      ctannualPremiumTotal =
        this.state.data[0][i].annualpremium + ctannualPremiumTotal
    }

    this.setState({ prorataPremiumTotalForEdit: ctprorataPremiumTotal })
    this.setState({ termPremiumTotalForEdit: cttermPremiumTotal })
    this.setState({ annualPremiumTotalForEdit: ctannualPremiumTotal })
  }

  getRiskCoverName = val => {
    const { riskCoverDrop } = this.state
    const cover = riskCoverDrop.find(item => item.riskCoverId === Number(val))
    return cover ? cover.riskCoverName : null
  }

  //function to get riskcover multiple selection
  riskcoverChange = async value => {
    // console.log('need data from here',value);

    if (value !== 'Select Value') {
      // console.log(value)
      this.setState({ policyriskcover: value.toString() })
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskItemsByCoverId/${value}/${this.state.selectedInsurer}`,
          'GET',
        )
        if (response.success == false) {
          this.setState({
            riskItemList: [],
          })
        }

        if (response.success && response.data.length > 0) {
          const data = response.data
          const selectedCoverName = this.getRiskCoverName(value)

          this.setState({
            riskItemList: data,
            policyriskcover: selectedCoverName,
            riskcoverid: value,
          })
        }
      } catch (error) {
        console.error('Error fetching risk cover:', error)
      }
    }

    this.setState({ policyCoverValue: value })
  }



  paymenttermChange(value) {
    const [datePart, timePart] = this.state.policyStartDate.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);

    // Create Date object (note: month is 0-indexed)
    const startDate = new Date(year, month - 1, day);

    // Add the months from payment term
    const monthsToBeAdded = parseInt(this.state.policyDuration, 10);
    const expiryDate = new Date(startDate);
    expiryDate.setMonth(expiryDate.getMonth() + monthsToBeAdded);

    // Format new expiry date back to "DD-MM-YYYY HH:mm:ss"
    const formatNumber = (n) => (n < 10 ? '0' + n : n);
    const formattedExpiryDate =
      `${formatNumber(expiryDate.getDate())}-${formatNumber(expiryDate.getMonth() + 1)}-${expiryDate.getFullYear()} 00:00:00`;

    // Set state
    this.setState({
      paymentterm: value,
      policyexpirytdate: formattedExpiryDate
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form

    let riskCoverList =
      this.state.riskCoverDrop.length > 0 &&
      this.state.riskCoverDrop.map((item, i) => {
        return (
          <option key={i} value={item.riskCoverId}>
            {item.riskCoverName}
          </option>
        )
      }, this)
    let paymenttermList = [3, 4, 6, 12].map((term) => (
      <Select.Option key={term} value={term.toString()}>
        {term}
      </Select.Option>
    ));
    let riskNameList =
      this.state.riskItemList.length > 0 &&
      this.state.riskItemList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.riskItemId}>
            {item.riskItemName}
          </Select.Option>
        )
      }, this)

    let InsuranceList =
      this.state.insurerList.length > 0 &&
      this.state.insurerList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.id}>
            {item.firstName && item.lastName
              ? `${item.firstName} ${item.lastName}`
              : item.name || `Insurer ${item.id}`}
          </Select.Option>
        )
      }, this)

    return (
      <Layout className="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>

        <div className=" dash-bg-white">
          <Row gutter={[16, 24]}>
            <Col xs={12} sm={24} md={12} lg={12}>
              <div className="flex justify-between">
                <h5
                  style={{
                    color: '#F15A2B',
                    fontWeight: '500',
                    fontSize: '20px',
                    marginBottom: '0',
                  }}>
                  <b>
                    CRM Policy{' '}
                    {/* <label
                      style={{
                        color: '#F15A2B',
                        fontWeight: '700',
                        fontSize: '20px',
                      }}>
                      {localStorage.getItem('productName')}
                    </label> */}
                  </b>
                </h5>
              </div>
            </Col>
            <Col xs={12} sm={24} md={12} lg={12}>
              <div className="right-text">
                {this.state.clientId !== null && (
                  <label>
                    <b>Policy Number : {this.state.policynumber}</b>
                  </label>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <div className=" dash-bg-white">
          <Row gutter={[16, 24]}>
            <Col xs={12} sm={24} md={12} lg={12}>
              <h3
                style={{
                  color: '#F15A2B',
                  fontWeight: '700',
                  fontSize: '20px',
                  margin: '0',
                }}>
                Basic Customer Details
              </h3>
            </Col>
            <Col xs={12} sm={24} md={12} lg={12}>
              <div className="align-right">
                <Button
                  size="default"
                  onClick={() => window.location.href = '/policies'}
                  style={{
                    color: '#6c757d',
                    borderColor: '#6c757d',
                    marginRight: '10px'
                  }}>
                  Go Back
                </Button>
              </div>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col xs={12} sm={24} md={24} lg={24}>
              <div
                className="form-item"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}></div>
            </Col>
          </Row>
          <Row gutter={(2, [12])} style={{ marginTop: '10px' }}>
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Entity Type">
                <Select
                  value={this.state.entitytype}
                  // defaultValue="Domestic"
                  onChange={this.ShowHideCorporateName}>
                  <Option value="Business">Business</Option>
                  <Option value="Individual">Individual</Option>
                </Select>
              </Form.Item>
            </Col>
            {this.state.clientfirstname !== '' && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="First Name">
                  <Input
                    placeholder="Enter Firstname"
                    onChange={this.onInputchange}
                    name="clientfirstname"
                    value={
                      this.state.clientfirstname.includes('undefined')
                        ? this.state.clientfirstname.slice(9)
                        : this.state.clientfirstname
                    }
                  />
                </Form.Item>
              </Col>
            )}
            {this.state.clientsurname !== '' && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Sur Name">
                  <Input
                    name='clientsurname'
                    placeholder="Enter surname"
                    value={this.state.clientsurname}
                    onChange={this.onInputchange}
                  />
                </Form.Item>
              </Col>
            )}
            {this.state.clientcorporatename !== '' && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Corporate Name">
                  <Input
                    disabled
                    value={this.state.clientcorporatename}
                    placeholder="Corporate name"
                    onChange={this.onInputchange}
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Contact Number">
                <Input
                  name='clientcontactnumber'
                  placeholder="eg:987654321"
                  value={this.state.clientcontactnumber}
                  onChange={this.onInputchange}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Email Address">
                <Input
                  name='clientemailaddress'
                  placeholder="abc@gmail.com "
                  value={this.state.clientemailaddress}
                  onChange={this.onInputchange}
                />
              </Form.Item>
            </Col>
            {this.state.clientage !== 0 && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Age">
                  <Input name='clientage' placeholder="eg:24" value={this.state.clientage} onChange={this.onInputchange} />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="National Id">
                <Input
                  name='nationalid'
                  placeholder="Enter national id"
                  value={this.state.nationalid}
                  onChange={this.onInputchange}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item label="Address">
                <TextArea
                  name='clientaddress1'
                  placeholder="Enter Address"
                  value={this.state.clientaddress1}
                  onChange={this.onInputchange}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} md={12} lg={8}>
            <Form.Item label=" Address 2">
              <TextArea placeholder="Enter Address" value={this.state.clientaddress2} />
            </Form.Item>
          </Col> */}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Suburb">
                <Input name='suburb' placeholder="Enter Suburb" value={this.state.suburb} onChange={this.onInputchange} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="City">
                <Input name='city' placeholder="Enter City" value={this.state.city} onChange={this.onInputchange} />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className=" dash-bg-white">
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
              marginBottom: '20px',
            }}>
            Policy Details
          </h3>
          <Row gutter={[16, 24]}>
            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Insurer">
                <Select
                  value={this.state.selectedInsurer || undefined}
                  disabled
                  showArrow={false}
                  open={false}
                  style={{ display: 'inline', width: '100%' }}
                  dropdownStyle={{ display: 'none' }}
                >
                  {InsuranceList}
                </Select>
              </Form.Item>

            </Col>
            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Policy Start Date">
                <DatePicker
                  style={{ width: '100%' }}
                  value={moment(
                    new Date(this.state.policyStartDate),
                    this.state.dateFormat,
                  )}
                  placeholder="Policy Start Date"
                  onChange={this.startdateChange}
                />
              </Form.Item>
            </Col>

              <Col xs={24} md={12} lg={5}>
              <Form.Item label="Policy Expiry Date">
                <DatePicker
                  style={{ width: '100%' }}
                  value={moment(
                    new Date(this.state.policyexpirytdate),
                    this.state.dateFormat,
                  )}
                  placeholder="Policy Expiry Date"
                  onChange={this.expirydateChange}
                />
              </Form.Item>
            </Col>     

            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Payment Term">
                <Select
                  value={this.state.paymentterm}
                  onChange={this.paymenttermChange}
                  defaultValue="Payment Term"
                  style={{ display: 'inline' }}
                  disabled={!this.state.renewButton}
                >
                  {paymenttermList}
                </Select>
              </Form.Item>
            </Col>

            {this.state.paymentterm === '12' && (
              <Col xs={20} md={12} lg={4}>
                <Form.Item label="Is Monthly Deduction">
                  <Checkbox
                    checked={this.state.isMonthlyDeduction}
                    onChange={e =>
                      this.setState({ isMonthlyDeduction: e.target.checked })
                    }
                  />
                </Form.Item>
              </Col>
            )}



            {this.state.productId === 1 || this.state.productId === 2 ? (
              <Col xs={24} md={12} lg={5}>
                <Form.Item label="Policy End Date">
                  <DatePicker
                    style={{ width: '100%' }}
                    value={moment(
                      new Date(this.state.policyexpirytdate),
                      this.state.dateFormat,
                    )}
                    disabled
                    placeholder="Policy End Date"
                    onChange={this.enddateChange}
                  />
                </Form.Item>
              </Col>
            ) : (
              ''
            )}

            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Currency">
                <Input value={this.state.currency} disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Risk Insurance Limit">
                <Input value={this.state.reinsuranceLimit} disabled />
              </Form.Item>
            </Col>
          </Row>
        </div>

        {/* <div className=" dash-bg-white">
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
              marginBottom: '20px',
            }}>
            Product Details
          </h3>

          <Form
            onSubmit={
              this.state.productId === 3 || this.state.productId === 5
                ? this.handleSubmitForFCP
                : this.handleSubmit
            }
            id="my-form">
            <Row gutter={[16, 24]}>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Policy Cover">
                  <Input
                    value={this.state.policyCoverValue || ''}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Risk Item">
                  <Input
                    value={
                      this.state.riskItemName ||
                      this.state.policydetail?.riskitemdetails?.[0]?.riskitemname ||
                      ''
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

          

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Date of Birth">
                    <DatePicker
                      disabledDate={current =>
                        current.isAfter(moment().subtract(1, 'day')) ||
                        current.isBefore(moment().subtract(64, 'years'))
                      }
                      disabled={
                        this.state.riskCoverFromApi.length > 0 ? false : true
                      }
                      onChange={this.DobFcp}
                    />
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Age">
                    <Input
                      placeholder="Age"
                      value={this.state.ageFcp}
                      disabled
                    />
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Relationship">
                    {getFieldDecorator('relation', {
                      initialValue: '',
                      rules: [
                        {
                          required: this.state.isRequired,

                          message: 'Please input Relationship!',
                        },
                      ],
                    })(
                      <Select>
                        <Option value="">---Select--</Option>
                        <Option value="Principal Member">
                          Principal Member
                        </Option>
                        <Option value="Spouse">Spouse</Option>
                        <Option value="Child">Child</Option>
                        <Option value="Grand Parent">Grand Parent</Option>
                        <Option value="Other">Other</Option>
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Name">
                    {getFieldDecorator('name', {
                      initialValue: '',
                      rules: [
                        {
                          required: this.state.isRequired,

                          message: 'Please input Name!',
                        },
                      ],
                    })(<Input placeholder="Name" />)}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Gender">
                    {getFieldDecorator('gender', {
                      initialValue: '',
                      rules: [
                        {
                          required: this.state.isRequired,

                          message: 'Please input gender!',
                        },
                      ],
                    })(
                      <Select>
                        <Option value="">---Select--</Option>
                        <Option value="Male">Male</Option>
                        <Option value="Female">Female</Option>
                      </Select>,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.cellphone === true && (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Model">
                    {getFieldDecorator('address', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Cellphone model!',
                          whitespace: false,
                        },
                      ],
                    })(<Input placeholder="Cellphone Model" />)}
                  </Form.Item>
                </Col>
              )}

              {(this.state.cellphone === false && this.state.productId === 1) ||
                (this.state.cellphone === false && this.state.productId === 2) ||
                (this.state.cellphone === false && this.state.productId === 4) ? (
                <Col xs={24} sm={24} md={12} lg={4}>
                  <Form.Item label="Address/Item Details">
                    {getFieldDecorator('address', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Address!',
                          whitespace: false,
                        },
                      ],
                    })(<Input placeholder="Type Address" />)}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              <Col xs={24} sm={24} md={12} lg={4} style={{ display: 'none' }}>
                <Form.Item label="Cover type">
                  <Input
                    value={this.state.coverType}
                    placeholder="Cover Type"
                    disabled
                  />
                </Form.Item>
              </Col>
             
              <Col xs={24} sm={24} md={12} lg={3}>
                <Form.Item label="Sum Insured">
                  <Input
                    value={this.state.sumInsured || ''}
                    disabled
                  />
                </Form.Item>
              </Col>

            

              {productNameInLocalStorage === 'LEGAL INSURANCE' ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label={'Minimum Monthly Payment'}>
                    <Input
                      placeholder={'Minimum Monthly Payment'}
                      disabled
                      value={parseFloat(this.state.Minimum_rate).toFixed(2)}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item
                    label={
                      this.state.productId === 3
                        ? 'Minimum Rate'
                        : this.state.productId === 5
                          ? 'Minimum Pay-out'
                          : 'Minimum Rate(%)'
                    }>
                    <Input
                      placeholder={
                        this.state.productId === 3
                          ? 'Minimum Rate'
                          : this.state.productId === 5
                            ? 'Minimum Pay-out'
                            : 'Minimum Rate(%)'
                      }
                      disabled
                      value={parseFloat(this.state.Minimum_rate).toFixed(2)}
                    />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} md={12} lg={2}>
                <Form.Item
                  label={
                    this.state.productId === 3
                      ? 'Rate'
                      : this.state.productId === 5
                        ? 'PayOut'
                        : 'Rate(%)'
                  }>
                  {getFieldDecorator('rate', {
                    initialValue: parseFloat(this.state.rate).toFixed(2),
                    rules: [
                      {
                        required: true,
                        message: 'Please enter Rate!',
                        whitespace: false,
                      },
                      {
                        validator: (_, value, callback) => {
                          const rateValue = parseFloat(value);
                          const minRate = parseFloat(this.state.Minimum_rate);
                          if (isNaN(rateValue) || rateValue <= minRate) {
                            callback(`Rate must be greater than ${minRate}`);
                          } else {
                            callback();
                          }
                        },
                      },
                    ],
                  })(
                    <Input
                      placeholder={
                        this.state.productId === 3
                          ? 'Rate'
                          : this.state.productId === 5
                            ? 'PayOut'
                            : 'Rate(%)'
                      }
                      onChange={e => this.setState({ rate: e.target.value })}
                    />
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={3}>
                <div className="add-button">
                  <Button
                    htmlType="submit"
                    size="default"
                    className="add-secondary">
                    Add
                  </Button>
                </div>
              </Col>

              {this.state.editingRecordId != null && (
                ((this.state.policyStatus?.toLowerCase() !== 'active') ||
                  (this.state.policyStatus?.toLowerCase() === 'active' &&
                    ['insureradmin', 'underwriter'].includes(
                      (localStorage.getItem('userRole') || '').toLowerCase()
                    )))
                && (
                  <Col xs={24} md={12} lg={3}>
                    <div className="add-button">
                      <Button
                        type="button"
                        size="default"
                        className="add-secondary"
                        onClick={this.handleEditSubmit}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                )
              )}


            </Row>
          </Form>
        </div> */}

        <div className="dash-bg-white no-padding">
          <div className="table-grid-bx width-11">
            <Table
              rowKey="Id"
              className="table-scroll-auto"
              columns={
                this.state.productId === 3 || this.state.productId === 5
                  ? this.state.columnsForFCP
                  : this.state.columns
              }
              dataSource={this.state.data}
              pagination={false}
              footer={() => {
                const totals = {
                  prorata: Number(this.state.prorataPremiumTotalForEdit) || 0,
                  annualpremium: Number(this.state.annualPremiumTotal) || 0,
                  termpremium: Number(this.state.termPremiumTotal) || 0,
                };

                let globalTaxes = this.state.taxes.filter(tax => tax.taxName.indexOf("Government levy") < 0);
                let taxAmounts = [];

                const productName = (localStorage.getItem("productName") || "").toLowerCase();
                const isMotor = productName.includes("motor");

                taxAmounts = this.state.taxes
                  .filter(tax => {
                    // Only include Government Levy for motor
                    if (tax.taxName.toLowerCase().includes("government levy")) {
                      if (!isMotor) return false;
                      if (this.state.entitytype === "Individual") {
                        return tax.taxName.toLowerCase().includes("private");
                      } else if (this.state.entitytype === "Business") {
                        return tax.taxName.toLowerCase().includes("commercial");
                      }
                      return false;
                    }
                    return true; // include all other taxes
                  })
                  .map(tax => {
                    let amounts;

                    if (isMotor && (tax.taxName.toLowerCase().includes("private") || tax.taxName.toLowerCase().includes("commercial"))) {
                      const months = Number(this.state.paymentterm) || 12;
                      const prorated = (tax.ratePercentage / 12) * months;
                      const levyValue = Math.max(prorated, 2);

                      amounts = {
                        prorata: 0,
                        annualpremium: tax.ratePercentage,
                        termpremium: levyValue,
                      };

                    } else if (tax.taxName.toLowerCase().includes("stamp duty")) {
                      debugger;
                      if (tax.type.toLowerCase() == 'fixed amount') {
                        amounts = {
                          annualpremium: tax.ratePercentage,
                          termpremium: (tax.ratePercentage / 12),
                        };
                      }
                      else {
                        amounts = {
                          annualpremium: Math.min(totals.annualpremium * (tax.ratePercentage / 100), 100000),
                          termpremium: Math.min(totals.termpremium * (tax.ratePercentage / 100), 100000),
                        };
                      }

                    } else {
                      amounts = {
                        annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
                        termpremium: totals.termpremium * (tax.ratePercentage / 100),
                      };
                    }

                    return { ...tax, amounts };
                  });
                const grandTotals = {
                  annualpremium:
                    totals.annualpremium +
                    taxAmounts.reduce((sum, t) => sum + t.amounts.annualpremium, 0),
                  termpremium:
                    // totals.termpremium +
                    taxAmounts.reduce((sum, t) => sum + Math.round(t.amounts.termpremium, 2), 0),
                };
                // this.setState({ grandTotals: grandTotals });
                const renderHeadingRow = () => (
                  <div
                    style={{
                      display: "flex",
                      borderBottom: "2px solid #000",
                      padding: "8px 0",
                      fontWeight: "bold",
                      background: "#fafafa",
                    }}
                  >
                    <div style={{ flex: 1, textAlign: "left", padding: "0 8px" }}></div>
                    {/* <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>
                      Prorata Premium
                    </div> */}
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>
                      Annual Premium
                    </div>
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>
                      Term Premium
                    </div>
                  </div>
                );

                const renderRow = (label, values, isBold = false) => (
                  <div
                    style={{
                      display: "flex",
                      borderBottom: "1px solid #e8e8e8",
                      padding: "8px 0",
                      fontWeight: isBold ? "bold" : "normal",
                    }}
                  >
                    <div style={{ flex: 1, textAlign: "left", padding: "0 8px" }}>
                      {label}
                    </div>
                    {/* <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>
                      {values.prorata?.toFixed(2) || ""}
                    </div> */}
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>
                      {values.annualpremium?.toFixed(2) || ""}
                    </div>
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>
                      {values.termpremium?.toFixed(2) || ""}
                    </div>
                  </div>
                );

                return (
                  <div>
                    {renderHeadingRow()}
                    {renderRow("Total", totals)}
                    {taxAmounts.map((tax, idx) => renderRow(tax.taxName, tax.amounts))}
                    {renderRow("Grand Total", this.state.grandTotals, true)}
                  </div>
                );
              }}
            />


          </div>
          <div className="btn-group-success">
            {(this.state.showSaveButton && !this.state.showRenewButton) && (
              <Button
                className="btn-success"
                size="default"
                value="submit"
                onClick={this.submitpolicy}
              >
                Save
              </Button>
            )}

            {this.state.showRenewButton && (
              <Button
                className="btn-success"
                size="default"
                value="submit"
                onClick={this.submitpolicy}
              >
                Renew Policy
              </Button>
            )}

          </div>
        </div>

      </Layout>
    )
  }
}

const WrappedEditCrmPolicy = Form.create({ name: 'Homeinsurance_list' })(
  withRouter(EditCrmPolicy),
)

export default WrappedEditCrmPolicy
